import React, { useEffect, useState } from 'react';
import { fetchReliabilityScoresYearly } from '../../../Service/APIService';
import TableHeader from '../../Custom/TableHeader';

const ReliabilityScoresYearly = ({ type, id }) => {
  const [scoreValues, setScoreValues] = useState([]);

  useEffect(() => {
    fetchReliabilityScoresYearly(type, id).then((res) => {
      const data = res.data.statusCode === 200 ? res.data.result : [];
      const months = data.map((t) => t.month);
      const SAIDI = data.map((t) => t.SAIDI);
      const SAIFI = data.map((t) => t.SAIFI);
      const CAIDI = data.map((t) => t.CAIDI);
      const CAIFI = data.map((t) => t.CAIFI);
      const obj = { months, SAIDI, SAIFI, CAIDI, CAIFI };
      setScoreValues(obj);
    });
  }, [id, type]);

  return (
    <TableHeader title={'Yearly Reliability Indices'}>
      <table className="tbl">
        <thead>
          <tr>
            <th>Reliability Metric</th>
            {scoreValues?.months?.map((item, index) => (
              <th key={`rel${index}`}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>SAIDI</td>
            {scoreValues?.SAIDI?.map((item, index) => (
              <td key={`saidi-${index}`}>{item}</td>
            ))}
          </tr>
          <tr>
            <td>SAIFI</td>
            {scoreValues?.SAIFI?.map((item, index) => (
              <td key={`saifi-${index}`}>{item}</td>
            ))}
          </tr>
          <tr>
            <td>CAIDI</td>
            {scoreValues?.CAIDI?.map((item, index) => (
              <td key={`caidi-${index}`}>{item}</td>
            ))}
          </tr>
          <tr>
            <td>CAIFI</td>
            {scoreValues?.CAIFI?.map((item, index) => (
              <td key={`caidi${index}`}>{item}</td>
            ))}
          </tr>
        </tbody>
      </table>
    </TableHeader>
  );
};

export default ReliabilityScoresYearly;
